import React from 'react';
// import PropTypes from 'prop-types'
import styles from './LoadingBlocker.module.scss';
import loaderSvg from '../../assets/svg/gh-animated-logo.svg';

export default function LoadingBlocker() {
  return (
    <div className={styles.blocker}>
      <img width={100} height={100} src={loaderSvg} />
    </div>
  );
}

LoadingBlocker.propTypes = {
};
